// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.course-list {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.btn-creat-course {
  float: right;
  margin-top: 5px;
}
tbody {
  cursor: pointer;
}

.title {
  display: flex;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
}

.dowload-file {
  cursor: pointer;
}

.fa-plus {
  margin-left: 5px;
  color: #198754;
}

.term hr {
  margin-top: 10px;
}

.submit-container {
  display: flex;
  float: right;
}

.btn-edit {
  margin-right: 5px;
}

.main-container {
  display: inline-grid;
}

.course-breadcrumb {
  margin-bottom: 30px !important;
}
.title-container-left,
.title-container-right {
  background: aliceblue;
  padding: 3px 0px;
  margin-bottom: 10px;
}
/* .title-container-left {
  border-left: 5px solid rgb(112, 171, 239);
}
.title-container-right {
  border-left: 5px solid rgb(112, 171, 239);
} */
.title-text {
  font-size: 22px;
  justify-content: center;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/pages/Course/Course.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;AACA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;;GAKG;AACH;EACE,eAAe;EACf,uBAAuB;EACvB,aAAa;AACf","sourcesContent":[".course-list {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 30px;\r\n}\r\n.btn-creat-course {\r\n  float: right;\r\n  margin-top: 5px;\r\n}\r\ntbody {\r\n  cursor: pointer;\r\n}\r\n\r\n.title {\r\n  display: flex;\r\n  justify-content: center;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n}\r\n\r\n.dowload-file {\r\n  cursor: pointer;\r\n}\r\n\r\n.fa-plus {\r\n  margin-left: 5px;\r\n  color: #198754;\r\n}\r\n\r\n.term hr {\r\n  margin-top: 10px;\r\n}\r\n\r\n.submit-container {\r\n  display: flex;\r\n  float: right;\r\n}\r\n\r\n.btn-edit {\r\n  margin-right: 5px;\r\n}\r\n\r\n.main-container {\r\n  display: inline-grid;\r\n}\r\n\r\n.course-breadcrumb {\r\n  margin-bottom: 30px !important;\r\n}\r\n.title-container-left,\r\n.title-container-right {\r\n  background: aliceblue;\r\n  padding: 3px 0px;\r\n  margin-bottom: 10px;\r\n}\r\n/* .title-container-left {\r\n  border-left: 5px solid rgb(112, 171, 239);\r\n}\r\n.title-container-right {\r\n  border-left: 5px solid rgb(112, 171, 239);\r\n} */\r\n.title-text {\r\n  font-size: 22px;\r\n  justify-content: center;\r\n  display: flex;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
